import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import type { Rdo } from "../../types.ts";
import { formatPercent } from "../../utils/format.ts";
import { isRdoEditable } from "../../utils/status.ts";

interface PerformanceSectionProps {
	rdo: Rdo;
	readOnly: boolean;
	onToggle: (enabled: boolean) => void;
}

function PerformanceValues({ rdo }: { rdo: Rdo }) {
	const performance = rdo.performance;
	if (!rdo.performanceEnabled) {
		return (
			<p className="rdo-editor__hint">
				{isRdoEditable(rdo.status)
					? "Esta seção não será incluída no PDF."
					: "Seção não incluída neste relatório."}
			</p>
		);
	}
	if (!performance) {
		return (
			<p className="rdo-editor__hint">
				O avanço previsto, o realizado e o desvio são calculados a partir do
				cronograma no momento da finalização e impressos no PDF.
			</p>
		);
	}
	if (performance.noBaseline) {
		return (
			<p className="rdo-editor__hint">
				Sem cronograma planejado até esta data; o PDF registra a ausência de
				linha de base.
			</p>
		);
	}
	return (
		<dl className="rdo-editor__facts rdo-editor__facts--counts">
			<div>
				<dt>Previsto</dt>
				<dd>{formatPercent(performance.planned)}</dd>
			</div>
			<div>
				<dt>Realizado</dt>
				<dd>{formatPercent(performance.actual)}</dd>
			</div>
			<div>
				<dt>Desvio</dt>
				<dd data-negative={performance.deviation < 0}>
					{formatPercent(performance.deviation)}
				</dd>
			</div>
			<div>
				<dt>Etapas concluídas</dt>
				<dd>{performance.completedCount}</dd>
			</div>
		</dl>
	);
}

export function PerformanceSection({
	rdo,
	readOnly,
	onToggle,
}: PerformanceSectionProps) {
	return (
		<section className="rdo-editor__section" aria-labelledby="rdo-performance">
			<h2 id="rdo-performance" className="rdo-editor__section-title">
				Desempenho
			</h2>
			<div className="rdo-editor__toggle">
				<Switch
					id="rdo-performance-enabled"
					checked={rdo.performanceEnabled}
					disabled={readOnly}
					onCheckedChange={onToggle}
				/>
				<Label htmlFor="rdo-performance-enabled">
					Incluir o desempenho da obra
				</Label>
			</div>
			<PerformanceValues rdo={rdo} />
		</section>
	);
}
